import { IDSchema } from "../model";

export function isUUID(value: unknown) {
    return IDSchema.safeParse(value).success;
}
